import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { User, LogOut } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import "./Header.css";
import logo from "../../assets/Logo.png";

interface HeaderProps {
  userName?: string;
}

const Header: React.FC<HeaderProps> = ({ userName }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try { await logout(); navigate("/"); }
    catch { window.alert("Não foi possível sair. Confira sua conexão e tente novamente."); }
  };

  const getProfileRoute = () => {
    if (user?.tipo === "Admin") {
      return "/profile-admin";
    } else if (user?.tipo === "Colaborador") {
      return "/profile-colaborador";
    } else {
      return "/profile-usuario-comum";
    }
  };

  const navegarParaPerfil = () => {
    navigate(getProfileRoute());
  };

  return (
    <header className="app-header">
      <div className="header-container">
        <div className="header-left">
          <Link to="/searchscreen" className="header-logo">
            <img src={logo} alt="Insecta" className="logo-img" />
            <span className="logo-text">Insecta - Banco de Imagens</span>
          </Link>
        </div>

        <div className="header-right">
          <div className="user-info">
            <span className="user-name">
              {userName || user?.nome_completo || "Usuário"}
            </span>
          </div>

          <div className="header-actions">
            <button className="botao-perfil" onClick={navegarParaPerfil} aria-label="Abrir meu perfil" title="Meu perfil">
              <User size={20} />
            </button>

            <button
              onClick={handleLogout}
              className="header-btn logout-btn"
              title="Sair"
            >
              <LogOut size={18} />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
